'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { navigateUrl } from '@/utils/client-request'
import { useLoginForm } from '@/lib/commerce/hooks'
import { TextField } from '../elements/Field'
import { authLink, authPrimaryButton, authTitle } from './authStyles'

export default function Login({ vendor }: { vendor?: any }) {
  const pathname = usePathname()
  const f = useLoginForm({ defaultRedirect: '/', refreshAfter: true, clearErrorParam: true })

  return (
    <div>
      <h1 className={authTitle}>Нэвтрэх</h1>
      <p className="mt-3 text-sm text-muted-foreground">Бүртгэлдээ нэвтэрнэ үү</p>

      <form onSubmit={f.handleLogin} className="mt-10 flex flex-col gap-5">
        <TextField label="Утасны дугаар / Имэйл" type="text" placeholder="Утасны дугаар эсвэл имэйл хаяг" value={f.emailOrPhone} onChange={e => f.setEmailOrPhone(e.target.value)} onKeyDown={f.handleKeyDown} autoComplete="username" autoFocus />
        <div>
          <TextField label="Нууц үг" type="password" placeholder="Таны нэвтрэх нууц үг" value={f.password} onChange={e => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} autoComplete="current-password" />
          <div className="mt-2 flex justify-end">
            <Link href={navigateUrl('/forgot', pathname)} className={`text-xs ${authLink}`}>Нууц үгээ мартсан уу?</Link>
          </div>
        </div>
        <button type="submit" disabled={f.loading} className={`mt-2 ${authPrimaryButton}`}>{f.loading ? 'Нэвтэрч байна…' : 'Нэвтрэх'}</button>
      </form>

      <p className="mt-8 pt-8 border-t border-border text-sm text-muted-foreground">
        Шинэ хэрэглэгч үү?{' '}
        <button type="button" onClick={f.routeToRegister} className={authLink}>Бүртгэл үүсгэх</button>
      </p>

      <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
        Дэлгүүрийн ажилтан бол{' '}
        <a href="https://app.shop.mn" target="_blank" rel="noopener noreferrer" className={authLink}>app.shop.mn</a>
        {' '}хаягаар нэвтэрнэ үү.
      </p>
    </div>
  )
}
